// Single source of truth for the admin navigation. Both the desktop sidebar
// (SidebarNav.vue) and the mobile drawer (MobileNav.vue) render from this list,
// so they can never drift apart again. Add a new dashboard here once and it
// appears in both.

export const navGroups = [
  {
    id: 'engagement',
    label: 'Users & Engagement',
    icon: 'engagement',
    items: [
      { label: 'Users', to: '/dashboard', icon: 'users' },
      { label: 'Reports', to: '/reports', icon: 'reports' },
      { label: 'Feedbacks', to: '/feedbacks', icon: 'inbox' },
      { label: 'Likes & Dislikes', to: '/thumbs', icon: 'thumbs' },
      { label: 'Content Feedback', to: '/content-feedback', icon: 'smile' },
      { label: 'Suggestions', to: '/suggestions', icon: 'lightbulb' }
    ]
  },
  {
    id: 'ai',
    label: 'AI & Content',
    icon: 'cpu',
    items: [
      { label: 'Prompts', to: '/prompts', icon: 'filetext' },
      { label: 'Prompt Tests', to: '/prompt-tests', icon: 'clipboardcheck' },
      { label: 'AI Comments', to: '/ai-comments', icon: 'messagecircle' },
      { label: 'Style Profiles', to: '/style-profiles', icon: 'brush' },
      { label: 'Year Ahead Reports', to: '/year-ahead', icon: 'filetext' },
      { label: 'Natal Chart Reports', to: '/natal-chart', icon: 'filetext' },
      { label: 'Compatibility Reports', to: '/compatibility', icon: 'filetext' },
      { label: 'Celebrity Twins', to: '/celebrity-twins', icon: 'filetext' },
      { label: 'Twin Figures', to: '/twin-figures', icon: 'users' },
      { label: 'Astrocartography', to: '/astrocartography', icon: 'filetext' },
      { label: 'Cities', to: '/cities', icon: 'globe' },
      { label: 'Signals', to: '/signals', icon: 'activity' },
      { label: 'AI Usage & Cost', to: '/ai-usage', icon: 'dollar' },
      { label: 'Transcriptions', to: '/transcriptions', icon: 'mic' },
      { label: 'Horoscope Podcast', to: '/horoscope-podcast', icon: 'headphones' }
    ]
  },
  {
    id: 'growth',
    label: 'Messaging & Growth',
    icon: 'megaphone',
    items: [
      { label: 'Notifications', to: '/notifications', icon: 'bell' },
      { label: 'Email Replies', to: '/email-replies', icon: 'mail' },
      { label: 'Social Hooks', to: '/social-hooks', icon: 'share' },
      { label: 'Playbooks', to: '/playbooks', icon: 'book' }
    ]
  },
  {
    id: 'revenue',
    label: 'Revenue',
    icon: 'creditcard',
    items: [
      { label: 'Adapty', to: '/adapty-webhooks', icon: 'zap' },
      { label: 'Cancellers', to: '/subscription-cancellers', icon: 'userx' }
    ]
  },
  {
    id: 'system',
    label: 'System & Ops',
    icon: 'sliders',
    items: [
      { label: 'Client Logs', to: '/client-logs', icon: 'terminal' },
      { label: 'System Logs', to: '/system-logs', icon: 'server' },
      { label: 'US Verify', to: '/verify-checks', icon: 'shield' },
      { label: 'Export', to: '/export', icon: 'download' }
    ]
  }
]

// Route names where the admin nav should NOT appear (public / end-user surfaces).
// Everything else is treated as an admin surface, so new admin pages get the nav
// automatically instead of silently missing it.
export const publicRouteNames = [
  'home',
  'admin',
  'promptTest',
  'AccountActivate',
  'VerifyCheckPage',
  'BirthChartPreview',
  'AstroLifePrompts'
]
